"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const storm_ui_1 = require("@amzn/storm-ui");
const regionUtils_1 = require("../../../utils/regionUtils");
const TranslationProvider_1 = require("../TranslationProvider/TranslationProvider");
const StyledRadioGroup = (0, styled_components_1.default)(storm_ui_1.RadioGroup) `
  margin-top: 10px;

  &&:first-of-type {
    margin-top: 8px;
  }
`;
const Container = (0, styled_components_1.default)('div') `
  padding: ${({ theme }) => theme.spacing.small};
  ${({ theme }) => theme.spacing.base};
  padding-block-start: ${({ theme }) => theme.spacing.mini};
  padding-block-end: ${({ theme }) => theme.spacing.small};

  ${(0, storm_ui_1.isMobileStyleMixin)((0, styled_components_1.css) `
    padding-block-end: ${({ theme }) => theme.spacing.base};
  `)}
`;
const RegionRadioGroup = ({ id, accounts, onChange, selected, }) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const handleChange = (value, event) => {
        // Get Account from Region
        const selectedAccount = accounts.find((a) => a.regionId === value);
        if (selectedAccount) {
            onChange(selectedAccount, event);
        }
    };
    return ((0, jsx_runtime_1.jsx)(Container, { children: (0, jsx_runtime_1.jsx)(StyledRadioGroup, { id: id, name: "radio-group", selectedValue: selected.regionId, onChange: handleChange, children: accounts.map(({ regionId }) => {
                return ((0, jsx_runtime_1.jsx)(storm_ui_1.RadioButton, { id: `${id}-${regionId}`, label: translate((0, regionUtils_1.getRegionLabel)(regionId)), value: regionId, "data-testid": `radio-group-${regionId}` }, `${id}-${regionId}`));
            }) }) }));
};
exports.default = RegionRadioGroup;
//# sourceMappingURL=RegionRadioGroup.js.map